export const ACTION_SUFFIX = '.Action.PP';
export const LABEL_SUFFIX = '.Label.PP';
export const LOGIN_SUFFIX = '.Login.PP';
export const MESSAGE_SUFFIX = '.Message.PP';
export const TITLE_SUFFIX = '.Title.PP';
export const LOOKUP_DATA_SUFFIX = '.DAT';
export const ORG_STRUCTURE_DESCRIPTION_PREFIX = 'ORGDS.';
export const PROCEDURE_CODE_DESCRIPTION_PREFIX = 'PRCDS.';
export const SPS_CODE_DESCRIPTION_PREFIX = 'SPSDS.';
export const ORG_STRUCTURE_LOCATION_DESCRIPTION_PREFIX = 'ORGLD.';
/*export const ORG_STRUCTURE_DESCRIPTION_SUFFIX = '.ORGDS.PP';
export const ORG_STRUCTURE_ERROR_MESSAGE_SUFFIX = '.ORGER.PP';
export const ORG_STRUCTURE_LOCATION_DESCRIPTION_SUFFIX = '.ORGLD.PP';
export const PROCEDURE_CODE_DESCRIPTION_SUFFIX = '.PRCDS.PP';
export const SPS_CODE_DESCRIPTION_SUFFIX = '.SPSDS.PP';*/

